export const initializeTermsAndRecaptcha = () => {
    const submitBtn = document.querySelector("button[type=submit].ace-add-to-cart") as HTMLButtonElement | null;
    const termsCheckboxes = document.querySelectorAll<HTMLInputElement>("input[type=checkbox][id^='termsAndConditions_cb']");
    const configEl = document.getElementById("recaptcha-config");

    if (!submitBtn || !configEl) return;

    const recaptchaEnabled = configEl.getAttribute("data-recaptcha-enabled") === "true";
    const recaptchaSiteKey = configEl.getAttribute("data-recaptcha-key") ?? undefined;

    let recaptchaValid = !recaptchaEnabled; // Valid by default if no recaptcha found

    const validateForm = () => {
        let termsAccepted = true;
        if (termsCheckboxes.length > 0) {
            termsAccepted = Array.from(termsCheckboxes).every(cb => cb.checked);
        }

        if (termsAccepted && recaptchaValid) {
            submitBtn.removeAttribute("disabled");
        } else {
            submitBtn.setAttribute("disabled", "disabled");
        }
    };

    termsCheckboxes.forEach(cb => {
        cb.addEventListener("change", validateForm);
    });

    validateForm();

    if (recaptchaEnabled && recaptchaSiteKey) {
        (window as any).grecaptcha.ready(() => {
            (window as any).grecaptcha.execute(recaptchaSiteKey, { action: "submit" }).then((token: string) => {
                const input = document.getElementById("g-recaptcha-response") as HTMLInputElement;
                if (input) {
                    input.value = token;
                }
                recaptchaValid = true;
                validateForm();
            });
        });
    }
};
